import React from "react";
import Slider from "react-slick";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function About() {

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    autoplay: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 992,
        settings: { slidesToShow: 2 }
      },
      {
        breakpoint: 576,
        settings: { slidesToShow: 1 }
      }
    ]
  };

  return (
    <div>

      <Helmet>
        <title>About Clear &amp; Clean | Commercial Cleaning Company Christchurch</title>
        <meta name="description" content="Learn about Clear &amp; Clean — a trusted commercial cleaning company serving Christchurch and Canterbury with reliable, high-quality office and industrial cleaning services." />
        <meta name="keywords" content="about Clear and Clean, commercial cleaning company Christchurch, cleaning company Canterbury, professional cleaners NZ" />
        <meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large" />
        <link rel="canonical" href="https://www.clearandclean.co.nz/about" />

        {/* Open Graph */}
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Clear &amp; Clean" />
        <meta property="og:url" content="https://www.clearandclean.co.nz/about" />
        <meta property="og:title" content="About Clear &amp; Clean | Commercial Cleaning Christchurch" />
        <meta property="og:description" content="Learn about Clear &amp; Clean, a trusted commercial cleaning company serving Christchurch and Canterbury." />
        <meta property="og:image" content="https://www.clearandclean.co.nz/images/bg_2.jpg" />
        <meta property="og:image:alt" content="About Clear &amp; Clean cleaning company" />
        <meta property="og:locale" content="en_NZ" />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="About Clear &amp; Clean | Commercial Cleaning Christchurch" />
        <meta name="twitter:description" content="Trusted commercial cleaning company serving Christchurch and Canterbury." />
        <meta name="twitter:image" content="https://www.clearandclean.co.nz/images/bg_2.jpg" />

        {/* BreadcrumbList */}
        <script type="application/ld+json">{`
          {
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [
              { "@type": "ListItem", "position": 1, "name": "Home",  "item": "https://www.clearandclean.co.nz/" },
              { "@type": "ListItem", "position": 2, "name": "About", "item": "https://www.clearandclean.co.nz/about" }
            ]
          }
        `}</script>

        {/* Structured Data — AboutPage */}
        <script type="application/ld+json">{`
          {
            "@context": "https://schema.org",
            "@type": "AboutPage",
            "url": "https://www.clearandclean.co.nz/about",
            "name": "About Clear & Clean",
            "description": "Clear & Clean is a professional commercial cleaning company based in Christchurch, New Zealand.",
            "publisher": {
              "@type": "LocalBusiness",
              "name": "Clear & Clean",
              "url": "https://www.clearandclean.co.nz",
              "telephone": "+64220866040",
              "address": {
                "@type": "PostalAddress",
                "streetAddress": "23 Conailles Street",
                "addressLocality": "Halswell",
                "addressRegion": "Canterbury",
                "postalCode": "8025",
                "addressCountry": "NZ"
              }
            }
          }
        `}</script>
      </Helmet>
      <section
        className="hero-wrap hero-wrap-2"
        style={{ backgroundImage: 'url("/images/bg_2.jpg")' }}
      >
        <div className="overlay" />

        <div className="container">
          <div className="row no-gutters slider-text align-items-end">
            <div className="col-md-9 pb-5">

              <p className="breadcrumbs mb-2">

                <span className="mr-2">
                  <Link to="/">
                    Home <i className="fa fa-chevron-right" />
                  </Link>
                </span>

                <span>
                  About us <i className="fa fa-chevron-right" />
                </span>

              </p>

              <h1 className="mb-0 bread">About Us</h1>

            </div>
          </div>
        </div>
      </section>

      <section className="ftco-section ftco-no-pb">
        <div className="container">
          <div className="row d-flex no-gutters">

            <div className="col-md-6 d-flex">
              <div
                className="img d-flex align-items-center justify-content-center py-5 py-md-0"
                style={{ backgroundImage: 'url("/images/about.jpg")' }}
              />
            </div>

            <div className="col-md-6 pl-md-5 pt-md-5">
              <div className="row justify-content-start py-5">
                <div className="col-md-12 heading-section">

                  <h2 className="mb-4">About our Company</h2>

                  <p>
                    CLEAR & CLEAN is a full-service professional cleaning
                    company delivering high-standard commercial and specialist
                    cleaning solutions throughout Christchurch and Canterbury.
                  </p>

                  <p>
                    We understand that cleaning is directly connected to
                    workplace health, safety compliance, presentation standards,
                    and staff wellbeing. For this reason, we operate structured
                    supervision systems and scheduled quality inspections.
                  </p>

                </div>
              </div>

              <div className="row ftco-counter py-5" id="section-counter">
                <div className="col-md-12 d-flex justify-content-center counter-wrap">
                  <div className="block-18">

                    <div className="text text-white">
                      <h2>CLEAR & CLEAN</h2>
                    </div>

                    <div className="text text-white">
                      <span>Clear Promises. Clean Results.</span>
                    </div>

                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </section>

      <section className="ftco-section testimony-section">

        <div className="container">

          <div className="row justify-content-center pb-5 mb-3">
            <div className="col-md-7 heading-section text-center">

              <span className="subheading">Testimonies</span>
              <h2>Happy Customer</h2>

            </div>
          </div>

          <div className="row">
  <div className="col-md-12">

    <Slider {...settings}>

      {[
        {
          img: "person_1.jpg",
          name: "Sarah Thompson",
          position: "Office Manager",
          text: "Clear & Clean has been maintaining our office for more than a year and the service has always been excellent. The team is professional, punctual, and very attentive to detail. Our workplace always looks fresh and welcoming. I would highly recommend their cleaning services."
        },
        {
          img: "person_2.jpg",
          name: "Michael Roberts",
          position: "Warehouse Supervisor",
          text: "We hired Clear & Clean to maintain our warehouse facility and the results have been outstanding. The team is reliable, efficient, and takes pride in their work. They consistently deliver a high standard of cleaning that helps keep our environment safe and organised."
        },
        {
          img: "person_3.jpg",
          name: "Emma Wilson",
          position: "Retail Store Owner",
          text: "Clear & Clean provides fantastic cleaning services for our retail store. Their staff are friendly, dependable, and always ensure everything is spotless before opening hours. It makes a huge difference for our customers when the store looks clean and well presented."
        },
        {
        img: "person_4.jpg",
        name: "Daniel Carter",
        position: "Facilities Coordinator",
        text: "Clear & Clean has been supporting our facility cleaning for several months and the experience has been excellent. Their team is reliable, well organised, and very attentive to detail. The workspace always looks clean, professional, and welcoming for both staff and visitors."
      }
      ].map((review, index) => (

        <div key={index}>

          <div className="testimony-wrap py-4">

            <div className="icon d-flex align-items-center justify-content-center">
              <span className="fa fa-quote-right" />
            </div>

            <div className="text">

              <div className="d-flex align-items-center mb-4">

                <div
                  className="user-img"
                  style={{ backgroundImage: `url("/images/${review.img}")` }}
                />

                <div className="pl-3">
                  <p className="name">{review.name}</p>
                  <span className="position">{review.position}</span>
                </div>

              </div>

              <p className="mb-1">{review.text}</p>

            </div>

          </div>

        </div>

      ))}

    </Slider>

  </div>
</div>

        </div>

      </section>

    </div>
  );
}

export default About;